import React, {useEffect, useState} from "react";
import TransferActivitiesTable from "./transferActivitiesTable/TransferActivitiesTable";
import {DateRangeFilter, SearchText, DateFilter} from "../../_defaultComponents/FilterComponents";
import {Col, Row, Select} from "antd";
import {useFetch} from "../../../hooks/useFetch";
import {useStore} from "../../../hooks/useStore";
import moment from "moment";
import Filters from "./filters/Filters";

const TransferActivities = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);

    const [filters, setFilters] = useState({
        groupName: urlSearchParams.get("groupName") || "",
        shipmentNumber: urlSearchParams.get("shipmentNumber") || "",
        cutOffDateRange: [],
        date: "",
        transferCenter: urlSearchParams.get("transferCenter") || "",
        groupStatus: urlSearchParams.get("groupStatus") || "",
        warehouseStatus: urlSearchParams.get("warehouseStatus") || "",
        deliveryStatus: urlSearchParams.get("deliveryStatus") || "",
        missingStatus: urlSearchParams.get("missingStatus") || "",
        transferCenters: null
    });

    const [page, setPage] = useState(1);
    const stores = useStore();

    const [transferCentersLoading, transferCenters] = useFetch({
        fetchFn: () => stores.transferStore.transferCenters({type: "main", owner: "external"}),
        dependencies: [],
        showLoading: true,
        initialCall: true
    });

    useEffect(() => {
        if (transferCenters?.result) {
            setFilters(prev => ({...prev, transferCenters}));
        }
    }, [transferCenters]);

    useEffect(() => {
        setPage(1);
    }, [filters]);

    const [shipmentTransferGroupsLoading, shipmentTransferGroups] = useFetch({
        fetchFn: () =>
            stores.transferStore.shipmentTransferGroupList({
                groupName: filters.groupName,
                shipmentNumber: filters.shipmentNumber,
                ...(filters.cutOffDateRange?.length === 2 && {
                    startDate: moment(filters.cutOffDateRange[0]).format("YYYY-MM-DD"),
                    endDate: moment(filters.cutOffDateRange[1]).format("YYYY-MM-DD")
                }),
                ...(filters.date && {date: filters.date.format("YYYY-MM-DD")}),
                transferCenter: filters.transferCenter,
                groupStatus: filters.groupStatus,
                warehouseStatus: filters.warehouseStatus,
                deliveryStatus: filters.deliveryStatus,
                missingStatus: filters.missingStatus,
                page,
                limit: 10
            }),
        dependencies: [filters, page],
        showLoading: true,
        initialCall: true
    });

    return (
        <>
            <h2>Transfer Aktiviteleri</h2>
            <Filters filters={filters} setFilters={setFilters} />
            <div>
                <TransferActivitiesTable
                    shipmentTransferGroups={shipmentTransferGroups}
                    shipmentTransferGroupsLoading={shipmentTransferGroupsLoading}
                    page={page}
                    setPage={setPage}
                />
            </div>
        </>
    );
};

export default TransferActivities;
